export const messageType = [
  {
    label: "业务流程消息",
    value: '01',
  },
  {
    label: "租后流程消息",
    value: '02',
  },
  {
    label: "签批流程消息",
    value: '03',
  },
  {
    label: "企业微信消息",
    value: '04',
  },
];

export const leaseType = [
  // {
  //   label: '12期',
  //   value: 12,
  // },
  {
    label: '24期',
    value: 24,
  },
  {
    label: '36期',
    value: 36,
  },
  {
    label: '48期',
    value: 48,
  },
];

export const leasePaymentType = [
  {
    label: '无',
    value: -1,
  },
  {
    label: '先付后租',
    value: 0,
  },
  {
    label: '先租后付',
    value: 1,
  },
]

export const agentTypeList = [
  {
    label: '直管',
    value: 1,
  },
  {
    label: '代管',
    value: 2,
  },
]

export const repaymentMethodList = [
  {
    label: '等额本息',
    value: 1,
  },
  {
    label: '等本等息',
    value: 2,
  },
  {
    label: '先息后本',
    value: 3,
  },
]

export const loanInputStoppingCase = [
  {
    label: '未邮寄资料',
    value: 0,
  },
  {
    label: '未履行代偿',
    value: 1,
  },
  {
    label: '未缴纳保证金',
    value: 2,
  },
]

export const agentLevelList = [
  {
    label: '省代',
    value: 0,
  },
  {
    label: '市代',
    value: 1,
  },
  {
    label: '一般代理',
    value: 2,
  },
]

// 审核状态
export const statusList = [
  {
    label: '待审核',
    value: 1,
  },
  {
    label: '通过',
    value: 2,
  },
  {
    label: '已拒绝',
    value: 3,
  },
]


/**
 * needReceiveFundType 枚举
 */
export const needReceiveFundTypeList = [
  {
    label: '客户还租',
    value: 1,
  },
  {
    label: '其他人还租',
    value: 2,
  },
  {
    label: '代理商还款',
    value: 3,
  },
  {
    label: '谈判违约结清',
    value: 4,
  },
  {
    label: '谈判继续还款违约保证金',
    value: 5,
  },
  {
    label: '违章罚款',
    value: 6,
  },
  {
    label: '保证金抵扣',
    value: 7,
  },
  {
    label: '法务违约结清',
    value: 8,
  },
  {
    label: '代理商违约结清',
    value: 9,
  },
  {
    label: '投诉结清',
    value: 10,
  },
]


/**
 * GPS 状态枚举
 */
export const GPS_STATUS = [
  {
    label: "离线",
    value: 0,
  },
  {
    label: "行驶",
    value: 1,
  },
  {
    label: "停车",
    value: 2,
  },
  {
    label: "从未上线",
    value: 3,
  },
  {
    label: "过期",
    value: 4,
  },
  {
    label: '休眠',
    value: 5,
  }
]

/**
 * GPS类型枚举 TODO
 */
export const GPS_TYPE = [
  {
    label: "防水mini",
    value: 1,
  },
  {
    label: "有线E3",
    value: 2,
  },
  {
    label: "无线206Dw",
    value: 3,
  },
  {
    label: "无线G50",
    value: 4,
  },
]